export interface ExcelPhraseRow {
  key: string;
  id?: string;
  local: string;
  fr: string;
  domain: string;
  source: string;
  lot: string;
  rowNumber: number;
  curationOrder?: number;
}

export interface ExcelPhraseCurationUpdate {
  phraseId: string;
  lot: string;
  domain: string;
  curationOrder: number;
}

export interface ExcelPhraseCurationSnapshot extends ExcelPhraseCurationUpdate {
  fileOrder: number;
}

export interface ExcelPhraseFormValue {
  local: string;
  fr: string;
  domain: string;
  source: string;
}

export const EMPTY_PHRASE_FORM: ExcelPhraseFormValue = {
  local: "",
  fr: "",
  domain: "",
  source: "",
};
